import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

const UnAuthPagesLayout = lazyRouteComponent(() => import('@/_containers/layouts/un-auth-pages'));

export const Route = createFileRoute('/_public')({
  component: UnAuthPagesLayout,
});
